module.exports = __webpack_public_path__ + "img/faqs_soc.ac8f9ff8.jpg";